import React, {useEffect, useState} from "react";
import CgFormCreator from "../../common/CgFormCreator";
import { useDispatch, useSelector } from "react-redux";
import { updatePassword } from "../../store/Myaccount/myaccountActions";
import { resetUpdateStatus } from "../../store/Myaccount/myaccountReducers";

const ChangePassword = () => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const dispatch = useDispatch();
    const { isLoading, updateSuccess, error, myaccountLogin } = useSelector((state) => state.myaccountLoginInformation);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmnewPassword, setConfirmNewPassword] = useState("");
    const [popupValue, setpopupValue] = useState(false);
    const [errors, setErrors] = useState(false);
    const [passwordNotMatch, setPasswordNotMatch] = useState(false);
    const [resetFormSubmit, setResetFormSubmit] = useState(false);
    const [passwordFormShow, setPasswordFormShow] = useState(true);

    useEffect(() => {
        dispatch(resetUpdateStatus());
        setPasswordFormShow(true);
    }, [dispatch]);

    const handleNewPasswordChange = (value) => {     
        if(!passwordRegex.test(value)){
            setpopupValue(true);
        } else {
            setpopupValue(false);
        }
    }
    
    const handleConfirmPasswordChange = (value) => {
        if(value !== newPassword){
            setPasswordNotMatch(true);
        } else {
            setPasswordNotMatch(false);
        }
    }

    useEffect(() => {
        if(currentPassword !== "" && newPassword !== "" && confirmnewPassword !== "" && !popupValue && !passwordNotMatch){
            setErrors(false);
        } else {
            setErrors(true);
        }
    },[currentPassword, newPassword, confirmnewPassword, popupValue, passwordNotMatch])
    

    const ChangePasswordSchema = [
        {
            component: "input",
            label: "Current Password*",
            type: "password",
            name: "currentPassword",
            required: true,
            placeholder:" ",
            onKeyChangeCallback:(name, value) => {
                setCurrentPassword(value);
            },
            valueChangeCallback: () => {},
        },
        {
            component: "input",
            label: "Enter New Password*",
            type: "password",
            name: "newpassword",
            required: true,
            placeholder:" ",
            onKeyChangeCallback:(name, value) => {
                handleNewPasswordChange(value);
                setNewPassword(value);
            },
            valueChangeCallback: () => {},
            popupErrorMsg: popupValue,
            tooltipMsg: "Password length must be at least eight(8) characters and must contain three of the four character types – upper case, lower case, numeric and/or special character"
        },
        {
            component: "input",
            label: "Confirm New Password*",
            type: "password",
            name: "confirmnewpassword",
            required: true,
            placeholder:" ",
            minLength:8,
            onKeyChangeCallback:(name, value) => {
                handleConfirmPasswordChange(value);
                setConfirmNewPassword(value); 
            },
            valueChangeCallback: () => {},
        },
    ];
    
    const savePassword = () => {  
        const userName = myaccountLogin?.user?.username;
        
        if (!userName) {
            console.error("Username is required but not available");
            return;
        }
        
        const passwordData = {
            currentPassword,
            newPassword,
            userName
        };
        dispatch(updatePassword(passwordData));
        
        setResetFormSubmit(true);
    }

    const resetForm = () => {
        return resetFormSubmit;
    }
    
    useEffect(() => {
        if(resetFormSubmit){
            setCurrentPassword("");
            setNewPassword("");
            setConfirmNewPassword("");
        }
    },[resetFormSubmit])
    
    useEffect(() => {
        if(updateSuccess) {
            setPasswordFormShow(false);
        }
    }, [updateSuccess]);

    const RenderChangePasswordFormCreator = () => {
        return (
            <>
            {
                passwordFormShow &&
                <div className="login-information-form">
                    {error && <p className="error-message">Failed to update password: {error}</p>}
                    {passwordNotMatch && <p className="passwordNotMatch" style={{ color: 'red' }}>Passwords do not match</p>}
                    <CgFormCreator
                        key={resetFormSubmit}
                        schema={ChangePasswordSchema}
                        primaryButton="Save"
                        onSubmitCallback={() => {
                            savePassword();
                        }}
                        resetValuesOnSubmit={resetForm()}
                        enablePrimaryBtn={!errors}
                        noCancel
                    />
                </div>
            }
            </>
        );
    }; 

    return(
        <div className="login-information Change-Password-content">
            <h2 className="info-section-header text-uppercase">Change Password</h2>
            <div className="login-section-content">
                {isLoading ? <div className="loading">Updating password...</div> : (
                    <>
                        {RenderChangePasswordFormCreator()}
                        {!passwordFormShow && 
                            <div className="success-message">
                                <p className="success-message-text">Your Password has been updated.</p>
                            </div>
                        }
                    </>
                )}
            </div>
        </div>
    )
}
export default ChangePassword;